import React from "react";
import { useParams } from "react-router-dom";
import { ServiceTimesReport } from "pages/Analytics/Experimental/Reports";

function Times() {
	const { id } = useParams();

	return (
		<ServiceTimesReport initialServiceId={id} />
	);
}

export default Times;
